import { render, staticRenderFns } from "./AssignLinkWidget.vue?vue&type=template&id=b7be5ce6&"
import script from "./AssignLinkWidget.vue?vue&type=script&lang=js&"
export * from "./AssignLinkWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports